import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { provideHooks } from 'redial';
import YourSavingsHubPage from '../components/YourSavingsHubPage/YourSavingsHubPage';
import { isUserLoggedIn } from 'apps/user/helpers';
import { requestLogin } from 'utils/loginAndRegistration/login';
import { fetchYourSavingsHub } from '../actions/yourSavingsHub';

class YourSavingsHubPageContainer extends Component {
  async componentDidMount() {
    this.checkLoginStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoggedIn !== this.props.isLoggedIn) {
      this.checkLoginStatus();
    }
  }

  checkLoginStatus() {
    const { isLoggedIn, router } = this.props;
    if (!isLoggedIn) {
      requestLogin(router);
    }
  }

  render() {
    const { isLoggedIn, ...restProps } = this.props;
    if (!isLoggedIn) {
      return null;
    }
    return <YourSavingsHubPage {...restProps} />;
  }
}

YourSavingsHubPageContainer.propTypes = {
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    getCurrentLocation: PropTypes.func.isRequired,
  }).isRequired,

};

const mapStateToProps = (state) => {
  const isLoggedIn = isUserLoggedIn(state.user);
  const stateData = getStateData(state);
  const productsBySku = getProductsBySku(state);
  const instantShopExists = stateData.easyShopping.tiles.some(tile =>
    tile.link.includes('displaySuggestedOrder.do')
  );
  const oReservedExists = get(stateData.easyShopping.tiles.find(tile =>
    tile.link.includes('/or-signup') || tile.link.includes('/or-management')
  ), 'link', undefined);

  return {
    isLoggedIn,
    productsBySku,
    instantShopExists,
    oReservedExists,
    ...stateData,
  };
};

const getStateData = (state) => {
  const paths = [
    { key: 'firstName', path: 'user.customerDetails.firstName', default: '' },
    { key: 'userRegistrationDate', path: 'user.customerDetails.userRegistrationDate', default: '' },
    { key: 'numberDelivered', path: 'user.shoppingDetails.placedOrdersCount', default: '' },
    { key: 'smartPassType', path: 'user.eligibilityDetails.smartPassDuration', default: '' },
    { key: 'numberOfCoupons', path: 'yourSavingsHub.data.numberOfCoupons', default: '' },
    { key: 'savingsForCoupons', path: 'yourSavingsHub.data.savingsForCoupons', default: '' },
    { key: 'pricePromiseVoucherCode', path: 'yourSavingsHub.data.pricePromiseVoucherCode', default: null },
    { key: 'pricePromiseVoucherValue', path: 'yourSavingsHub.data.pricePromiseVoucherValue', default: null },
    { key: 'graphicBanner1', path: 'yourSavingsHub.data.scribeContent.graphicBanner1', default: null },
    { key: 'graphicBanner2', path: 'yourSavingsHub.data.scribeContent.graphicBanner2', default: null },
    { key: 'productBySkuCarousel1', path: 'yourSavingsHub.data.scribeContent.productsCarousel1', default: [] },
    { key: 'productBySkuCarousel2', path: 'yourSavingsHub.data.scribeContent.productsCarousel2', default: [] },
    { key: 'productBySkuCarousel3', path: 'yourSavingsHub.data.scribeContent.productsCarousel3', default: [] },
    { key: 'basketItems', path: 'basket.items', default: [] },
    { key: 'productWarnings', path: 'basket.productWarnings.productWarnings', default: [] },
    { key: 'easyShopping', path: 'topNavigation.easyShoppingDropdown', default: {} },
  ];

  return paths.reduce((acc, { key, path, default: defaultValue }) => {
    acc[key] = get(state, path, defaultValue);
    return acc;
  }, {});
};

const getProductsBySku = (state) => {
  const extractProducts = (carousel) => carousel.sections.reduce((acc, section) => {
    section.fops.forEach(fop => {
      acc[fop.product.sku] = fop.product;
    });
    return acc;
  }, {});

  const productBySkuCarousel1 = extractProducts(
    get(state, 'yourSavingsHub.data.scribeContent.productsCarousel1', { sections: [] })
  );
  const productBySkuCarousel2 = extractProducts(
    get(state, 'yourSavingsHub.data.scribeContent.productsCarousel2', { sections: [] })
  );
  const productBySkuCarousel3 = extractProducts(
    get(state, 'yourSavingsHub.data.scribeContent.productsCarousel3', { sections: [] })
  );

  return {
    ...productBySkuCarousel1,
    ...productBySkuCarousel2,
    ...productBySkuCarousel3,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});
const ConnectedYourSavingsHubPageContainer = connect(mapStateToProps, mapDispatchToProps)(YourSavingsHubPageContainer);

export default provideHooks({
  fetch: ({ dispatch }) => dispatch(fetchYourSavingsHub()),
})(ConnectedYourSavingsHubPageContainer);

